import { render } from "./FutureObligation.vue?vue&type=template&id=6443148b"
import script from "./FutureObligation.vue?vue&type=script&lang=js"
export * from "./FutureObligation.vue?vue&type=script&lang=js"

import "./FutureObligation.vue?vue&type=style&index=0&id=6443148b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/FutureObligation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6443148b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6443148b', __exports__)) {
    api.reload('6443148b', __exports__)
  }
  
  module.hot.accept("./FutureObligation.vue?vue&type=template&id=6443148b", () => {
    api.rerender('6443148b', render)
  })

}


export default __exports__